<template>
    <div class="single-menu-item-container">
        <menu-item-image :item="menuItem" size="large" />
        
        <div class="single-menu-item-info">
            <div class="single-menu-item-summary">
                <serving-size :item="menuItem" />
                <nutrition-components :item="menuItem" :limit="4" />
            </div>
            
            <tags :item="menuItem" />
            <allergens :item="menuItem" variant="extra-large" />
            
            <div v-if="menuItem.Description" class="single-menu-item-description">
                {{ menuItem.Description }}
            </div>
            
            <button class="single-menu-item-link" @click="onMore">
                Full Nutrition Details
            </button>
        </div>
    </div>
</template>

<script>
import Allergens from '../../../components/allergens.vue';
import Tags from '../../../components/tags.vue';
import menuItemMixin from '../../../js/mixins/menuItemMixin';
import MenuItemImage from './menuItemImage.vue';
import NutritionComponents from './nutritionComponents.vue';
import ServingSize from './servingSize.vue';

export default {
    name: 'single-menu-item',
    components: {
        'menu-item-image': MenuItemImage,
        'nutrition-components': NutritionComponents,
        'allergens': Allergens,
        'tags': Tags,
        'serving-size': ServingSize
    },
    mixins: [menuItemMixin],
    props: {
        menuItem: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>
.single-menu-item-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
}

.single-menu-item-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.single-menu-item-summary {
    display: flex;
    flex-direction: column;
    font-size: 12px;
    gap: 12px;
}

.single-menu-item-description {
    font-size: 14px;
    line-height: 1.5;
    color: #333;
    padding: 8px 0;
}

.single-menu-item-link {
    color: #6B8B2C;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    margin-top: 8px;
    cursor: pointer;
}

.single-menu-item-link:hover {
    text-decoration: underline;
}
</style>